'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _CustomPackage = require('./CustomPackage.scss');var styles = _interopRequireWildcard(_CustomPackage);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CustomPackage = function CustomPackage(props) {return (
    _react2.default.createElement('div', { className: styles.customPackageWrapper },
      _react2.default.createElement('span', { className: styles.boldText },
        props.translate('interestedCustomPackage')),

      _react2.default.createElement(_reactRouter.Link, {
          className: styles.contactUs,
          to: (0, _appendLocale2.default)(props.locale, '/contact_us_realtor'),
          target: '_blank',
          onClick: props.saveDataToStorage },

        props.translate('contactUs'))));};exports.default =




CustomPackage;

CustomPackage.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  saveDataToStorage: _propTypes2.default.func.isRequired };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomPackage/CustomPackage.js
// module id = 2636
// module chunks = 0